'use client';
import React, { useEffect } from 'react';
import { useAuth } from '@edusense/shared-auth-core';
import Modal from './components/Modal';
import UnifiedTweetComposer from './UnifiedTweetComposer/UnifiedTweetComposer';
import { getModalTitle } from './utils/tweetUtils';
import { useComposeModal } from './hooks/useComposeModal';
import { TWEET_COMPOSER_TEST_IDS } from '@edusense/shared-constants';
export var ComposeModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, _param_mode = param.mode, mode = _param_mode === void 0 ? 'tweet' : _param_mode, _param_inline = param.inline, inline = _param_inline === void 0 ? false : _param_inline, _param_referenceTweet = param.referenceTweet, referenceTweet = _param_referenceTweet === void 0 ? null : _param_referenceTweet, onTweetSubmit = param.onTweetSubmit, placeholder = param.placeholder, _param_autoFocus = param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus;
    var user = useAuth().user;
    useEffect(function() {
        if (!isOpen) return;
        var handleModalCloseRequest = function() {
            onClose();
        };
        window.addEventListener('modal-close-request', handleModalCloseRequest);
        return function() {
            return window.removeEventListener('modal-close-request', handleModalCloseRequest);
        };
    }, [
        isOpen,
        onClose
    ]);
    var _useComposeModal = useComposeModal({
        mode: mode,
        onCloseAction: onClose,
        referenceTweet: referenceTweet,
        onTweetSubmit: onTweetSubmit,
        isOpen: isOpen
    }), images = _useComposeModal.images, setImagesAction = _useComposeModal.setImagesAction, handleTweetSubmitAction = _useComposeModal.handleTweetSubmitAction, instanceId = _useComposeModal.instanceId;
    if (inline) {
        return /*#__PURE__*/ React.createElement(UnifiedTweetComposer, {
            key: "inline-composer-".concat(instanceId, "-").concat(isOpen),
            mode: mode,
            referenceTweet: referenceTweet,
            onSubmitAction: handleTweetSubmitAction,
            placeholder: placeholder,
            autoFocus: autoFocus,
            isOpen: isOpen,
            images: images,
            setImagesAction: setImagesAction
        });
    }
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onClose: onClose,
        title: getModalTitle(mode),
        width: "lg"
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": TWEET_COMPOSER_TEST_IDS.MODAL_CONTAINER
    }, /*#__PURE__*/ React.createElement(UnifiedTweetComposer, {
        key: "modal-composer-".concat(instanceId, "-").concat(isOpen),
        mode: mode,
        referenceTweet: referenceTweet,
        onSubmitAction: handleTweetSubmitAction,
        placeholder: placeholder,
        autoFocus: autoFocus,
        isOpen: isOpen,
        images: images,
        setImagesAction: setImagesAction,
        user: user
    })));
};
export default ComposeModal;
